import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pipeline-destinations-group-copy"
export default class extends Controller {
  static targets = [ "account", "pipeline", "commit", "configuration" ];

  connect() {
  }

  accountChange() {
    this.accountTarget.form.submit();
  }

  pipelineChange() {
    this.accountTarget.form.submit();
  }

  configurationChange(event) {
    const key = event.target.dataset.configurationKey;
    const display = event.target.checked;

    document.querySelectorAll(`div[data-configuration-key="${key}"]`).forEach(e => {
      if (display) {
        e.classList.remove("not-copied");
      }
      else {
        e.classList.add("not-copied");
      }
    });
  }

  commit(event) {
    event.preventDefault();

    this.commitTarget.form.target_account_id.value = this.accountTarget.value;
    this.commitTarget.form.target_pipeline_id.value = this.pipelineTarget.value;

    this.commitTarget.form.submit();
  }
}
